import {
  IChannel,
  IColor,
  IConsumerType,
  IDecorationTech,
  IDesign,
  IFlavorScent,
  IGlobalProduct,
  ILicensedProperty,
  ILicensor,
  IMarketingMaterial,
  IPlugType,
  IProductHier,
  ITcc,
} from "../../types/data.interface";
import { MasterArtworkNameState } from "../meta-artwork/artwork-name/data.type";
import { MasterArtworkNumberState } from "../meta-artwork/artwork-number/data.type";
import { MasterArtworkCollectionState } from "../meta-artwork/collections/data.type";
import {
  ItemNumberSearchesActionType,
  ItemNumberSearchesActionTypes,
  ItemNumberSearchesState,
} from "./data.type";
import { Option } from "./data.type";


const setNewGlobalProduct = (
  newGlobalProduct: IGlobalProduct | null,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_NEW_GLOBAL_PRODUCT,
  payload: { newGlobalProduct },
});

const setNewItemNumber = (itn_itemno: string, itn_itemnm: string): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_NEW_ITEM_NUMBER,
  payload: { itn_itemno, itn_itemnm },
});

const setCategory = (category: IProductHier | null): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_CATEGORY,
  payload: { category },
});

const setSubCategory = (
  subCategory: IProductHier | null,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_SUB_CATEGORY,
  payload: { subCategory },
});

const setProductLine = (
  productLine: IProductHier | null,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_PRODUCT_LINE,
  payload: { productLine },
});

const setConsumerPackagingType = (itn_cptype: IConsumerType | null): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_TYPE,
  payload: { itn_cptype },
});

const setConsumerPackagingLanguage = (
  itn_cplang: string
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_LANGUAGE,
  payload: { itn_cplang },
});


const setMarketingMaterial = (
  marketing_material_id: IMarketingMaterial | null,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_MARKETING_MATERIAL,
  payload: { marketing_material_id },
});

const setConsumerPackagingGlobalCode = (
  itn_cpgcod: string
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_GLOBAL_CODE,
  payload: { itn_cpgcod },
});

const setConsumerPackagingGlobalName = (
  itn_cpgnam: string): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_GLOBAL_NAME,
  payload: { itn_cpgnam },
});

const setIncludesLeafletManual = (
  itn_inclfm: Option<string> | null): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_INCLUDES_LEAFLET_MANUAL,
  payload: { itn_inclfm },
});

const setIncludesLeafletNumber = (itn_lfmnum: string): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_INCLUDES_LEAFLET_NUMBER,
  payload: { itn_lfmnum },
});

const setIncludesLeafletName = (itn_lfmnam: string): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_INCLUDES_LEAFLET_NAME,
  payload: { itn_lfmnam },
});

const setPlugType = (
  itn_plgtyp: IPlugType  | null
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_PLUG_TYPE,
  payload: { itn_plgtyp },
});

const setPlugName = (
  itn_plgnam: string,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_PLUG_NAME,
    payload: { itn_plgnam },
});

const setUPC12 = (
  itn_upc12d: string,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_UPC12,
  payload: { itn_upc12d },
});

const setEAN13D = (
   itn_ean13d: string,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_EAN13D,
  payload: { itn_ean13d },
});

const setRegulatoryRestrictions = ( itn_restri: string,): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_REGULATORY_RESTRICTIONS,
  payload: { itn_restri },
});

const setReleaseDate = (
   itn_relsdt: string,
): ItemNumberSearchesActionType => ({
   type: ItemNumberSearchesActionTypes.SET_RELEASE_DATE,
   payload: { itn_relsdt },
 });

const setLinePlanningStatus = (
   itn_lifsts: Option<string> | null,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_LINE_PLANNING_STATUS,
  payload: { itn_lifsts },
});

const setFiltersFromStorage = (
  filters: Partial<ItemNumberSearchesState>,
): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.SET_FILTERS_FROM_STORAGE,
  payload: { ...filters },
});

const resetAllData = (): ItemNumberSearchesActionType => ({
  type: ItemNumberSearchesActionTypes.RESET,
  payload: {},
});

export const ItemNumberSearchesActions = {
  setNewGlobalProduct,
  setNewItemNumber,
  setCategory,
  setSubCategory,
  setProductLine,
  setConsumerPackagingType,
  setConsumerPackagingLanguage,
  setMarketingMaterial,
  setConsumerPackagingGlobalCode,
  setConsumerPackagingGlobalName,
  setIncludesLeafletManual,
  setIncludesLeafletNumber,
  setIncludesLeafletName,
  setPlugType,
  setPlugName,
  setUPC12,
  setEAN13D,
  setRegulatoryRestrictions,
  setReleaseDate,
  setLinePlanningStatus,
  setFiltersFromStorage,
  resetAllData,
};
